import {RunSignature} from '../../../../types/run';

// eslint-disable-next-line import/no-cycle -- please fix if you can
export {fetchDirectURLByFilePath} from './directURLs';
// eslint-disable-next-line import/no-cycle -- please fix if you can
export {fetchExistingFilePathSet} from './existingFilePaths';

export type BaseFetchParams = {
  runSignature: RunSignature;
  filePaths: string[];
};
